(() => {
  function init(root) {
    if (root.dataset.ready) return;
    const data = JSON.parse(root.querySelector('[data-product-json]').textContent);
    const variants = data.variants;
    const fallback = root.querySelector('[data-variant-select]');
    const controls = root.querySelector('[data-options]');
    const buy = root.querySelector('button[data-buy]');
    const quote = root.querySelector('[data-add-kit-quote]');
    const status = root.querySelector('[data-quote-error]');
    const groups = [...controls.querySelectorAll('[data-option]')];
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD'}).format(cents / 100);
    let current = variants.find(v => String(v.id) === fallback.value) || variants[0];
    let quoteRequested = ['#installed-estimate', '#add-to-quote'].includes(location.hash);
    const selectCurrent = () => groups.forEach((group, index) => {
      const select = group.querySelector('select');
      if (select) select.value = current.options[index];
      group.querySelectorAll('input[type=radio]').forEach(input => {input.checked = input.value === current.options[index];});
    });
    const values = () => groups.map(group => group.querySelector('select')?.value || group.querySelector('input:checked')?.value);
    function update() {
      current = variants.find(v => v.options.every((value, i) => value === values()[i]));
      quote.disabled = !current;
      if (!current) {buy.disabled = true; return;}
      fallback.value = current.id;
      buy.disabled = !current.available;
      buy.textContent = current.available ? root.dataset.buy : root.dataset.unavailable;
      root.querySelector('[data-price]').textContent = money(current.price);
      root.querySelector('[data-sku]').textContent = current.sku || '';
      root.querySelector('[data-configuration]').textContent = current.options.join(' / ');
      const image = root.querySelector('[data-main-image]');
      const src = current.featured_image?.src;
      if (src && image) {image.src = src; image.removeAttribute('srcset'); image.alt = data.title + ' — ' + current.options.join(' / ');}
      const next = new URL(location.href);
      next.searchParams.set('variant', current.id);
      history.replaceState(history.state, '', next);
      controls.querySelectorAll('[data-aux-value]').forEach(label => {
        const match = variants.find(v => v.options[0] === label.dataset.auxValue && v.options.slice(1).every((value,i) => value === current.options[i+1]));
        const base = variants.find(v => v.options[0] === 'FOX 2.0 auxiliary shocks' && v.options.slice(1).every((value,i) => value === current.options[i+1]));
        if (match && base) label.querySelector('[data-delta]').textContent = match.price === base.price ? root.dataset.base : '+' + money(match.price - base.price);
      });
    }
    function addToQuote() {
      if (!current) return false;
      if (!window.WPOQuote?.add) {status.textContent = root.dataset.quoteError; status.hidden = false; return false;}
      status.hidden = true;
      window.WPOQuote.add({id:String(current.id), productId:String(data.id), title:data.title, options:current.options.join(' / '), sku:current.sku, price:current.price, currency:root.dataset.currency, kind:'parts', url:'/products/' + data.handle + '?variant=' + current.id});
      return true;
    }
    function applyQuoteIntent() {
      if (!quoteRequested || !window.WPOQuote?.add) return;
      quoteRequested = false;
      if (addToQuote()) {
        const next = new URL(location.href); next.hash = ''; history.replaceState(history.state, '', next);
      }
    }
    if (!current) return;
    root.dataset.ready = 'true';
    selectCurrent();
    root.querySelector('[data-fallback]').hidden = true;
    controls.hidden = false;
    controls.addEventListener('change', update);
    quote.addEventListener('click', addToQuote);
    document.addEventListener('wpo:quote-ready', applyQuoteIntent);
    window.addEventListener('hashchange', () => {quoteRequested = ['#installed-estimate', '#add-to-quote'].includes(location.hash); applyQuoteIntent();});
    window.addEventListener('popstate', () => {
      const id = new URL(location.href).searchParams.get('variant');
      const variant = variants.find(v => String(v.id) === id);
      if (variant) {current = variant; selectCurrent(); update();}
    });
    update();
    applyQuoteIntent();
  }
  document.querySelectorAll('[data-wpa-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-wpa-product]').forEach(init));
})();
